"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Drawable objects on the canvas should extend this class
 */
class Drawable {
    constructor(priority) {
        this.visibility = OPACITY.VISIBLE;
        this.priority = priority;
    }
    /**
     * @returns returns drawing priority
     */
    getPriority() {
        return this.priority;
    }
    setVisibility(v) {
        this.visibility = v;
    }
    getVisibility() {
        return this.visibility;
    }
    update(ctx, grid) {
        if (this.visibility == OPACITY.INVISIBLE)
            return;
        ctx.save();
        ctx.globalAlpha = (this.visibility == OPACITY.VISIBLE) ? 1.0 : 0.65;
        this.draw(ctx, grid);
        ctx.restore();
    }
    static isDrawable(object) {
        if (object == null)
            return false;
        const d = object;
        return d.draw !== undefined;
    }
}
exports.Drawable = Drawable;
var OPACITY;
(function (OPACITY) {
    OPACITY[OPACITY["VISIBLE"] = 0] = "VISIBLE";
    OPACITY[OPACITY["INVISIBLE"] = 1] = "INVISIBLE";
    OPACITY[OPACITY["TRANSPARENT"] = 2] = "TRANSPARENT";
})(OPACITY = exports.OPACITY || (exports.OPACITY = {}));
